import {
  Box,
  Flex,
  HStack,
  VStack,
  Text,
  Badge,
  Separator,
  Image,
} from "@chakra-ui/react";


export const OrderTile = ({
  id,
  date,
  status,
  total,
  items,
  orderNumber,
  onViewDetails,
}) => {
  const statusColor = {
    pending: "#F97350", 
    order_placed: "#F97350",
    unpaid: "#F97350",

    confirmed: "#2b92e4",
    processed: "#2b92e4",
    ready_to_ship: "#2b92e4",
    shipped: "#2b92e4", 
    in_transit: "#2b92e4",

    delivered: "#8dbd61",
    picked_up: "#8dbd61", 
    paid: "#8dbd61",

    cancelled: "#E53E3E",
    undelivered: "#E53E3E",
    returned: "#E53E3E",
    
  }[status?.toLowerCase()] || "gray.500";
  const displayId = id?.slice(0, 12).replace(/-/g, '').toUpperCase() || 'N/A';

  return (
    <Box
      borderWidth="1px"
      borderColor={"gray.200"}
      borderRadius="lg" 
      bg={"white"}
      p={4}
      shadow="md"
      _hover={{ shadow: "xl", transform: "translateY(-2px)" }} 
      transition="all 0.3s ease-in-out"
      cursor={"pointer"}
      onClick={onViewDetails}
      height="100%"
    >
      <Flex justify="space-between" align="center" mb={2}>
        <Text fontWeight="extrabold" fontSize="xl" color="gray.700">
          Order #{orderNumber}
        </Text>
        <Badge 
          bg={statusColor} 
          color={"white"} 
          px={3} 
          py={1}
          borderRadius="full" 
          textTransform="capitalize"
        >
          {status}
        </Badge>
      </Flex>

      <HStack 
        spacing={4} 
        fontSize="sm"
        color="gray.600" 
        mb={3}
      >
        <Text>
            <Text as="span" fontWeight="semibold">Date:</Text> {date}
        </Text>
        <Text>
          <Text as="span" fontWeight="semibold">Total:</Text>{" "}
          <Text as="span" fontWeight="extrabold" color="gray.800">
             {total}
          </Text>
        </Text>
      </HStack>

      <Separator mb={4} borderColor="gray.200" /> 

      <VStack align="stretch" spacing={4}>
        {items && items.slice(0, 3).map((item, idx) => {
          const thumb = item.variant?.thumb_images.length > 0 ?
            item.variant?.thumb_images?.[0].url ? item.variant?.thumb_images?.[0]?.url :
            item.variant?.images?.[0]?.url :
            "/placeholder.png";

          return (
            <HStack key={idx} align="center" spacing={3} w="full">
              <Image
                src={thumb}
                alt={item.product?.name || "Product"}
                boxSize="70px" // Slightly smaller image
                objectFit="cover"
                borderRadius="md"
                fallbackSrc="/placeholder.png"
              />

              <VStack 
                align="start" 
                spacing={0}
                flex={1} 
                minWidth={0} 
              >
                <Text
                  fontSize="md"
                  fontWeight="bold"
                  color="gray.700"
                  lineHeight="tight"
                  isTruncated 
                  noOfLines={1} 
                  mb={1}
                >
                  {item.product?.name || "Unknown Product"}
                </Text>

                <Text fontSize="xs" color="gray.500">
                  <Text as="span" fontWeight="semibold">Qty:</Text> {item.quantity} 
                  {(item.variant?.size?.name || item.variant?.color?.name) && ' | '}
                  <Text as="span" textTransform="capitalize">
                      {item.variant?.size?.name || ""}{" "}
                      {item.variant?.color?.name || ""}
                  </Text>
                </Text>
              </VStack>
            </HStack>
          );
        })}

        {items && items.length > 3 && (
          <Text 
            fontSize="sm" 
            fontWeight="medium" 
            color="blue.500" 
            mt={2}
          >
            + {items.length - 3} more item{items.length - 3 > 1 ? 's' : ''}
          </Text>
        )}
      </VStack>
    </Box>
  );
};